<template>
    <div>
        <div>
            <i class="far fa-edit float-right text-primary pointer mr-2 mb-2" @click="showEditPrompt"></i>
        </div>
        <div class="mt-3" aria-describedby="descriptionHelp">
            <vs-upload
                ref="test"
                :text="$t('addFile')"
                :showUploadButton="false"
            />
        </div>
        <small id="descriptionHelp" class="form-text text-muted">{{ isEnVersion ? model.descriptionEn : model.description }}</small>

        <vs-prompt :title="$t('editor.common.editComponentProperties')"
                   :accept-text="$t('buttons.ok')"
                   :cancel-text="$t('buttons.cancel')"
                   :active.sync="activePrompt"
                   :is-valid="validationSuccess"
                   @cancel="cancelPrompt"
                   @close="cancelPrompt"
                   color="primary">
            <div>
                <div v-if="model.locked">
                    <h4 class="text-danger"><i class="fas fa-lock"></i> {{ $t('registers.dynamic.gridHeaders.locked') }}</h4>
                </div>

                <FieldTemplateSelector v-model="model"
                                       :isFormField="isFormField"
                                       :isAuxRegisterField="isAuxRegisterField"
                                       :isEventFieldCode="isEventFieldCode">
                </FieldTemplateSelector>

                <vs-input :label="$t('editor.common.name')" v-model="model.name" />
                <span class="text-danger" v-if="!validName">{{ $t('validation.requiredField') }}</span>

                <div class="row mt-2 mb-2 pl-3">
                    <vs-checkbox v-model="model.isTemplate">{{ $t('editor.common.saveAsTemplate') }}</vs-checkbox>
                </div>

                <vs-input :label="$t('editor.common.nameEN')" v-model="model.nameEn"></vs-input>

                <vs-input :label="$t('editor.common.description')" v-model="model.description" />
                <vs-input :label="$t('editor.common.descriptionEn')" v-model="model.descriptionEn" />
            </div>
        </vs-prompt>
    </div>
</template>

<script>
    import { EditorComponentModel } from '@/models/models';
    import FieldTemplateSelector from '@/components/editor/FieldTemplateSelector'
    import { Culture } from '@/models/enums';

    export default {
        props: {
            value: String,
            model: {
                type: EditorComponentModel
            },
            isFormField: {
                type: Boolean,
                default: false
            },
            isAuxRegisterField: {
                type: Boolean,
                required: false
            },
            isEventFieldCode: {
                type: Boolean,
                required: false
            },
        },
        components: {
            FieldTemplateSelector
        },
        data() {
            return {
                activePrompt: false,
                originalModel: new EditorComponentModel()
            }
        },
        methods: {
            showEditPrompt(event) {
                this.originalModel = new EditorComponentModel(this.model);
                this.activePrompt = true;
            },
            cancelPrompt() {
                this.changeModelToOriginalModel();
            },
            changeModelToOriginalModel() {
                this.model.name = this.originalModel.name;
                this.model.nameEn = this.originalModel.nameEn;
            }
        },
        computed: {
            validName() {
                return this.model.name.length > 0;
            },
            validationSuccess() {
                // this.mode.locked - Locked for edition
                return !this.model.locked && this.validName;
            },
            isEnVersion() {
                return this.$store.getters.currentCulture === Culture.EN;
            },
        }
    }
</script>

<style scoped>
    .vs-input {
        width: 100%;
    }

    ::v-deep {
        .vs-dialog {
            min-width: 800px !important;
            height: auto;
        }
    }
</style>
